export default `
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  font-weight: 400;
`
